import React from 'react'
import FAQ from './FAQ'
import './style.css'

const FAQSection = () => {
  return (
    <div id="FAQSection" className="faq-section-layout">
    <div className='key-features-container'>
    <div className='main-container'>
    <br/>
    <div className="key-feature-section-title">Frequently Asked Questions</div>
    <br/>
    <br/>
    <div className='faq-grid-section'>
    <FAQ/><FAQ/>
    <FAQ/><FAQ/><FAQ/><FAQ/>
    </div>
      <br/>
    </div></div></div>
  )
}

export default FAQSection
